import {Modal} from '@forecast-it/design-system';

interface DeleteAttachmentModalProps {
	open: boolean;
	filename: string;
	loading: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

/**
 * FOR-261: deletion is permanent from the reader's point of view, so it takes an
 * explicit confirmation naming the file. Mirrors DeleteTicketModal.
 */
export function DeleteAttachmentModal({open, filename, loading, onConfirm, onCancel}: DeleteAttachmentModalProps) {
	if (!open) return null;

	return (
		<Modal onCloseModal={onCancel}>
			<Modal.Title>Delete file</Modal.Title>
			<Modal.Content>
				Are you sure you want to delete <strong>{filename}</strong>? This action cannot be undone.
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={onConfirm} disabled={loading}>
					{loading ? 'Deleting…' : 'Delete'}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={onCancel} disabled={loading}>
					Cancel
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
}
